import { render } from "./ContactReport.vue?vue&type=template&id=27d1b601"
import script from "./ContactReport.vue?vue&type=script&lang=js"
export * from "./ContactReport.vue?vue&type=script&lang=js"

import "./ContactReport.vue?vue&type=style&index=0&id=27d1b601&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__